import { state, text } from "@/theme/colors";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import { Box, Stack, Typography } from "@mui/material";
import { FC } from "react";

// Date when the login method changes: 2026/08/01
const LOGIN_METHOD_CHANGE_DATE = new Date(2026, 7, 1);
// Notice is only displayed until the end of 2026/08/31
const LOGIN_NOTICE_END_DATE = new Date(2026, 7, 31, 23, 59, 59, 999);

const changeYear = LOGIN_METHOD_CHANGE_DATE.getFullYear();
const changeMonth = LOGIN_METHOD_CHANGE_DATE.getMonth() + 1;
const changeDay = LOGIN_METHOD_CHANGE_DATE.getDate();

export const LoginNotice: FC = () => {
  if (new Date() > LOGIN_NOTICE_END_DATE) return null;

  return (
    <Box
      width={680}
      maxWidth="100%"
      p={2}
      borderRadius="6px"
      border={`1px solid ${state.warning_1}`}
      sx={{ backgroundColor: state.incomplete_secondary }}
    >
      <Stack gap={1}>
        <Stack direction="row" alignItems="center" gap={1.5}>
          <ErrorRoundedIcon sx={{ fontSize: 24, color: state.warning_1 }} />
          <Typography variant="body14Bold" color={text.primary}>
            {`${changeMonth}月${changeDay}日からのログイン方法変更のお知らせ`}
          </Typography>
        </Stack>

        <Typography component="p" variant="body14170" color={text.secondary} pl="36px" m={0}>
          {`事前のご案内のとおり、irohanaのログイン方法が${changeYear}年${changeMonth}月${changeDay}日をもって変更されました。別途メールにてご案内している初回ログイン用のURLより改めてパスワード設定をお願いします。`}
          <br />
          ご不明点がございましたら、
          <Typography
            component="a"
            variant="body14Semi170"
            color={state.link_1}
            href="https://support.iro-hana.com/irohana-visa-irohana-center-38c5d48302ae80c6ba7bcbbedc681330"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ textDecoration: "underline" }}
          >
            irohanaログイン方法変更のご案内
          </Typography>
          &nbsp;をご確認ください。
        </Typography>
      </Stack>
    </Box>
  );
};
